import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';
import { passwordValidator } from '../customValidator';


@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegistrationPage implements OnInit {
  registrationForm !: FormGroup;
  passwordsDoNotMatch: boolean = false;


  constructor(private fb: FormBuilder,private router:Router,private apiService:ApiService) {}

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm() {
    // Initialize the form with required fields and validation rules
    this.registrationForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      age: ['', [Validators.required]],
      gender: ['male', [Validators.required]],
      accent: ['', [Validators.required]],
      username: ['', [Validators.required]],
      // email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, passwordValidator]],
      confirmPassword: ['', [Validators.required]],
    }, {
      validator: this.passwordMatchValidator
    });
  }

  // Custom validator to check if password and confirm password match
  passwordMatchValidator(group: FormGroup) {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }

  onSubmit() {
    try{
      // if (this.registrationForm.valid) {
        const formData = this.registrationForm.value;
        // Call the AuthService to register the user
        this.apiService.registerUser(formData).subscribe(response => {
          // Handle successful registration, e.g., redirect to the login page
          console.log('User registered successfully:', response);
          this.router.navigate(['/login']);
          alert("User created Successfully !!!");
        }, error => {
          // Handle registration error
          console.error('Registration error:', error);
        });
      // }
    }catch(error){
      console.log('Form is invalid');
    }
    
  }


  navigateToLogin() {
    // Navigate back to the login page when the link is clicked
    this.router.navigate(['/login']);
  }

  checkPasswords(): void {
    this.passwordsDoNotMatch = this.registrationForm.value.password !== this.registrationForm.value.confirmPassword;
  }
}

